/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Evaluating_OneaiInputs */



/**
* | output |
* | --- |
* | "What makes oneAI different?" |
*
* @param {Uno_Welcome_Suggestion_Evaluating_OneaiInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_evaluating_oneai = /** @type {((inputs?: Uno_Welcome_Suggestion_Evaluating_OneaiInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Evaluating_OneaiInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was macht oneAI anders?")
	return /** @type {LocalizedString} */ ("What makes oneAI different?")
});